<script lang="ts">
  import type { ImageDetails } from 'proto/image';
	
	import { observeOnceOff } from '$lib/serv/dom';
  import { toSrc, type MaybeImageDetails } from '$lib/serv/image-details';
	import { onMount } from 'svelte';

	export let image: Parameters<typeof toSrc> | ImageDetails | string | undefined = undefined;
	export let alt: string;
	export let id: string | undefined = "";

	export let src: string | undefined | null = undefined;
	export let sizes: string | undefined | null = undefined;
	export let srcset: string | undefined | null = undefined;

	let imageLoaded: boolean = false;

	$: _src = Array.isArray(image) ? toSrc(...image) : toSrc(image);

	let img: any;
	let intersected: boolean = false;

	let loadedSrc: string;
	$: {
		if ((_src || src) && intersected) {
			loadedSrc = _src || src || '';
		}
	}

	onMount(() => {
		img.onload = () => { // TODO: use preloadImage instead of an inline img element
			imageLoaded = true;
		}

		observeOnceOff(img, (elm) => {
			if (_src || src) loadedSrc = _src || src || '';
			intersected = true;
		});
	});
</script>

<!-- TODO: ...$$restProps causes CSP inline event handler violation -->
<img bind:this={img} src={loadedSrc} {alt} {sizes} {srcset} class:loaded={imageLoaded} data-testid={`image-${id}`}> <!-- TODO: Chat to Gareth about loadedSrc -->

<style lang="scss">
	@use 'ease';
	img {
		opacity: 0;
		transition: opacity 200ms ease.$out-quart;
		&.loaded { opacity: 1; }
	}
</style>